// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, Fragment, useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import ErrorHandler from "../../../components/shared/with-error-handler";
import loadable from "@loadable/component";
import { LazyComponent } from "../../../components/shared/lazy-image";
import HomeBanner from "../../../components/desktop/home-banner";
import SellEasySteps from "../../../components/desktop/sell-easy-steps";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";

const TwitterCarousel = loadable(() => import("../../../components/desktop/twitter-carousel"));
const TestimonialCarouselRevamp = loadable(() => import("../../../components/desktop/testimonial-carousel-revamp"));
const PilotFaq = loadable(() => import("../../../components/desktop/pilot-faq"));
const WhyCars = loadable(() => import("../../../components/desktop/why-cars"));
const SimplestWay = loadable(() => import("../../../components/desktop/simplest-way"));

const SellMarketingInfo = ({
    updateLeadSourceConnect
}) => {
    useC2bCleverTap("Sell_car");

    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        updateLeadSourceConnect(C2B_LEAD_TYPES.SELL_MARKETING_ORIGINAL);
    }, [updateLeadSourceConnect]);

    const onClick = () =>  window.scrollTo(0, 0);

    const renderDefaultPage = () => (
        <Fragment>
            <ErrorHandler>
                <div styleName={"styles.buyCarsVariant"}>
                    <HomeBanner />
                    <div styleName={"styles.wrapper"}>
                        <SellEasySteps/>
                        <LazyComponent>
                            <WhyCars faqs={faqs} setFaqs={setFaqs} />
                        </LazyComponent>
                    </div>
                    <div styleName={"styles.customerTestimonials"}>
                        <LazyComponent>
                            <TestimonialCarouselRevamp currentPage={"home"} showDate={false}/>
                        </LazyComponent>
                    </div>
                    <div styleName={"styles.twitterCarousel"}>
                        <LazyComponent>
                            <TwitterCarousel />
                        </LazyComponent>
                    </div>
                </div>
                <div styleName={"styles.faqWrapper"}>
                    <LazyComponent>
                        <PilotFaq faqs={faqs} columns={1} />
                    </LazyComponent>
                    <a href="/faq/" target="_blank" styleName={"styles.allfqa"}>view all faqs</a>
                </div>
                <LazyComponent>
                    <SimplestWay onClick={onClick} />
                </LazyComponent>
            </ErrorHandler>
        </Fragment>
    );

    return (
        <div>
            {renderDefaultPage()}
        </div>
    );
};
SellMarketingInfo.propTypes = {
    route: PropTypes.any,
    match: PropTypes.object.isRequired,
    selectedCity: PropTypes.object,
    background: PropTypes.string.isRequired,
    updateLeadSourceConnect: PropTypes.func,
    isCitySelectionSkipped: PropTypes.bool,
    enableC2CPromotion: PropTypes.bool,
    cashBonus: PropTypes.object,
    sellerOnlineExp: PropTypes.any,
    covidUIExperiment: PropTypes.bool,
    applicableCityForSellOnline: PropTypes.func,
    isSellOnlineFlow: PropTypes.bool,
    setIsSellOnlineConnect: PropTypes.func,
    completeSellOnlineCities: PropTypes.array
};

export default SellMarketingInfo;
